import React from 'react';

const ModeHelpTooltip = ({ onClose }) => {
  return (
    <div className="mode-help-overlay">
      <div className="mode-help-content">
        <h4>Custom Path Mode Help</h4>
        <button className="close-button" onClick={onClose}>×</button>
        <div className="help-text">
          <p><strong>Purpose:</strong> Manually design routes for multiple vehicles in a VRP scenario. Assign customers to specific vehicles and determine the visiting sequence for each vehicle based on your domain knowledge.</p>
          
          <p><strong>Prerequisites:</strong></p>
          <ul>
            <li>At least 3 points set up in Setup Mode (1 depot + 2+ customers)</li>
            <li>Depot (start point) designated</li>
          </ul>

          <p><strong>Operation Steps:</strong></p>
          <ol>
            <li><strong>Set Number of Vehicles:</strong>
              <ul>
                <li>Use + / - buttons or enter number directly (1-10)</li>
                <li>More vehicles can reduce distance but increase costs</li>
                <li>Each vehicle gets a unique color</li>
              </ul>
            </li>
            <li><strong>Select Vehicle:</strong>
              <ul>
                <li>Click on a vehicle card to make it active</li>
                <li>Active vehicle highlighted with border</li>
                <li>Only one vehicle active at a time</li>
              </ul>
            </li>
            <li><strong>Build Vehicle Routes:</strong>
              <ul>
                <li>For selected vehicle, click customers from Remaining Points list</li>
                <li>Or click directly on customer markers on map</li>
                <li>Customers are added to that vehicle's route</li>
                <li>Route appears on map with vehicle's color</li>
              </ul>
            </li>
            <li><strong>View Route Information:</strong>
              <ul>
                <li>Each vehicle card shows:
                  <ul>
                    <li>Customer sequence (Depot → C1 → C2 → ... → Depot)</li>
                    <li>Route distance</li>
                    <li>Number of customers assigned</li>
                  </ul>
                </li>
              </ul>
            </li>
            <li><strong>Modify Routes:</strong>
              <ul>
                <li>Click × button on a customer to remove from route</li>
                <li>Customer returns to Remaining Points list</li>
                <li>Can reassign to different vehicle</li>
                <li>Click "Undo" to remove last added customer</li>
              </ul>
            </li>
            <li><strong>Manage Vehicle Paths:</strong>
              <ul>
                <li>Click "Reset" on vehicle card to clear that vehicle's route</li>
                <li>Click "Reset All Paths" to clear all vehicle routes</li>
              </ul>
            </li>
            <li><strong>Complete and Confirm:</strong>
              <ul>
                <li>Assign all customers to vehicles</li>
                <li>Each vehicle route automatically closes (returns to depot)</li>
                <li>Click "Confirm All Paths" to save solution</li>
              </ul>
            </li>
          </ol>

          <p><strong>Vehicle Route Features:</strong></p>
          <ul>
            <li><strong>Color Coding:</strong> Each vehicle has unique color on map</li>
            <li><strong>Independent Routes:</strong> Each vehicle route managed separately</li>
            <li><strong>Real-time Distance:</strong> Distance updates as customers added</li>
            <li><strong>Remaining Points:</strong> Shows unassigned customers</li>
            <li><strong>Auto Closure:</strong> Routes automatically return to depot</li>
          </ul>

          <p><strong>Route Planning Strategies:</strong></p>
          <ul>
            <li><strong>Geographic Clustering:</strong> Assign nearby customers to same vehicle</li>
            <li><strong>Load Balancing:</strong> Distribute customers evenly among vehicles</li>
            <li><strong>Minimize Distance:</strong> Keep vehicle routes compact</li>
            <li><strong>Capacity Awareness:</strong> Respect vehicle capacity constraints</li>
          </ul>

          <p><strong>Tips:</strong></p>
          <ul>
            <li>Start with optimal vehicle count (not too many, not too few)</li>
            <li>Assign geographically close customers to same vehicle</li>
            <li>Try to balance route lengths across vehicles</li>
            <li>Avoid route crossings between different vehicles</li>
            <li>Use Undo to experiment with different assignments</li>
            <li>Compare with algorithm solution to learn optimization</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ModeHelpTooltip; 